// extracted by mini-css-extract-plugin
module.exports = {"max_width":"600px","padding_width":"14px"};